import { IRouteItem, IRoutes } from "@techzyapp/ui-lib";

function injectItems(
  items: IRouteItem[],
  map: Record<string, string>,
): IRouteItem[] {
  return items.map((item) => ({
    ...item,
    ...(map[item.path] ? { accessKeys: [map[item.path]] } : {}),
    children: item.children ? injectItems(item.children, map) : undefined,
  }));
}

export function injectAccessKeys(
  routes: IRoutes,
  map: Record<string, string>,
): IRoutes {
  return { ...routes, items: injectItems(routes.items, map) };
}
